import { StripePlugin } from '@vue-stripe/vue-stripe';

export const { STRIPE_PUBLIC_KEY } = process.env;
export const stripePlugin = StripePlugin;
export const stripeOptions = {
  pk: STRIPE_PUBLIC_KEY,
};
